import React, { useState } from "react";
import styles from "./learningZoneToolbox.module.css";
import { TbVocabulary } from "react-icons/tb";
import { MdFormatColorText } from "react-icons/md";
import { FaQuestion } from "react-icons/fa";
import { FaImage } from "react-icons/fa6";
import VocabularyModal from "../learningToolVocabulary/vocabularyModal/VocabularyModal";
import ClozeModal from "../learningToolCloze/clozeModal/ClozeModal";
import MultipleChoiceModal from "../learningToolMultipleChoice/multipleChoiceModal/MultipleChoiceModal";
import ImgToWordModal from "../learningToolImgToWord/imgToWordModal/ImgToWordModal";

const LearningZoneToolbox = ({ learningZoneId, addNewToolToList }) => {
  /* This component allows the user to create a new learning tool */

  const [isNewVocabularyToolModalOpen, setIsNewVocabularyToolModalOpen] =
    useState(false);
  const [isNewClozeToolModalOpen, setIsNewClozeToolModalOpen] = useState(false);
  const [
    isNewMultipleChoiceToolModalOpen,
    setIsNewMultipleChoiceToolModalOpen,
  ] = useState(false);
  const [isNewImgToWordToolModalOpen, setIsNewImgToWordToolModalOpen] =
    useState(false);

  /**
   * Show the vocabulary tool modal, to allow the user to create a new vocabulary tool
   */
  const onAddVocabularyTool = () => {
    setIsNewVocabularyToolModalOpen(true);
  };

  /**
   * Show the cloze tool modal, to allow the user to create a new cloze tool
   */
  const onAddClozeTool = () => {
    setIsNewClozeToolModalOpen(true);
  };

  /**
   * Show the multiple choice tool modal, to allow the user to create a new multiple choice tool
   */
  const onAddMultipleChoiceTool = () => {
    setIsNewMultipleChoiceToolModalOpen(true);
  };

  /**
   * Show the image to word tool modal, to allow the user to create a new image to word tool
   */
  const onAddImgToWordTool = () => {
    setIsNewImgToWordToolModalOpen(true);
  };

  /**
   * Close the currently open modal
   */
  const closeModal = () => {
    setIsNewVocabularyToolModalOpen(false);
    setIsNewClozeToolModalOpen(false);
    setIsNewMultipleChoiceToolModalOpen(false);
    setIsNewImgToWordToolModalOpen(false);
  };

  return (
    <div className={styles.toolbox}>
      <h2>Learning Tools</h2>
      <p>Click on a tool to add it to the learning zone:</p>
      <div className={styles.btnsContainer}>
        <button onClick={onAddVocabularyTool}>
          <span className={styles.widgetIcon}>
            <TbVocabulary />
          </span>
          Vocabulary
        </button>
        <button onClick={onAddClozeTool}>
          <span className={styles.widgetIcon}>
            <MdFormatColorText />
          </span>
          Cloze
        </button>
        <button onClick={onAddMultipleChoiceTool}>
          <span className={styles.widgetIcon}>
            <FaQuestion />
          </span>
          Multiple Choice Question
        </button>
        <button onClick={onAddImgToWordTool}>
          <span className={styles.widgetIcon}>
            <FaImage />
          </span>
          Match Image to Word
        </button>
      </div>
      <div className={styles.modalsContainer}>
        <VocabularyModal
          header={`Add Vocabulary Learning Tool`}
          unitContent={null}
          approveBtnText="Create"
          cancelBtnText="Cancel"
          show={isNewVocabularyToolModalOpen}
          onClose={closeModal}
          onConfirm={(newTool) => {
            addNewToolToList(newTool);
            closeModal();
          }}
          learningToolId={null}
          learningZoneId={learningZoneId}
        />

        <ClozeModal
          header={`Add Cloze Learning Tool`}
          unitContent={null}
          approveBtnText="Create"
          cancelBtnText="Cancel"
          show={isNewClozeToolModalOpen}
          onClose={closeModal}
          onConfirm={(newTool) => {
            addNewToolToList(newTool);
            closeModal();
          }}
          learningToolId={null}
          learningZoneId={learningZoneId}
        />

        <MultipleChoiceModal
          header={`Add Multiple Choice Learning Tool`}
          unitContent={null}
          approveBtnText="Create"
          cancelBtnText="Cancel"
          show={isNewMultipleChoiceToolModalOpen}
          onClose={closeModal}
          onConfirm={(newTool) => {
            addNewToolToList(newTool);
            closeModal();
          }}
          learningToolId={null}
          learningZoneId={learningZoneId}
        />

        <ImgToWordModal
          header={`Add Img To Word Learning Tool`}
          unitContent={null}
          learningToolId={null}
          approveBtnText="Create"
          cancelBtnText="Cancel"
          show={isNewImgToWordToolModalOpen}
          onClose={closeModal}
          onConfirm={(newTool) => {
            addNewToolToList(newTool);
            closeModal();
          }}
          learningZoneId={learningZoneId}
        />
      </div>
    </div>
  );
};

export default LearningZoneToolbox;
